import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/router/routes';

import { BasicDrawer } from '@/components/ui/basic-drawer';

import { CaseForm } from '../case-form';

export function NewCasePage() {
  const navigate = useNavigate();

  const handleAddNewCase = (newCaseId: string) => {
    navigate(ROUTES.PROCESS_CASE.replace(':caseId', newCaseId) + '?new-case=true', {
      replace: true,
    });
  };

  const onClose = () => {
    navigate(-1);
  };

  return (
    <BasicDrawer open={true} onClose={onClose}>
      <CaseForm setNewCaseId={handleAddNewCase} />
    </BasicDrawer>
  );
}
